var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './list.component.less';
import { clone, forEach, isString } from 'lodash';
import { Stratus } from '@stratusjs/runtime/stratus';
import { element } from 'angular';
import 'angular-material';
import 'angular-sanitize';
import { isJSON, safeUniqueId } from '@stratusjs/core/misc';
import { cookie } from '@stratusjs/core/environment';
const min = !cookie('env') ? '.min' : '';
const packageName = 'idx';
const moduleName = 'member';
const componentName = 'list';
const localDir = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/src/${moduleName}/`;
const localDistStyle = `${Stratus.BaseUrl}${Stratus.DeploymentPath}@stratusjs/${packageName}/dist/${packageName}.bundle.min.css`;
Stratus.Components.IdxMemberList = {
    bindings: {
        elementId: '@',
        tokenUrl: '@',
        detailsLinkPopup: '@',
        detailsLinkUrl: '@',
        detailsLinkTarget: '@',
        orderOptions: '@',
        options: '@',
        template: '@',
        variableSync: '@'
    },
    controller($anchorScroll, $attrs, $q, $mdDialog, $rootScope, $scope, $timeout, $window, Idx) {
        $scope.uid = safeUniqueId(packageName, moduleName, componentName);
        $scope.elementId = $attrs.elementId || $scope.uid;
        Stratus.Instances[$scope.elementId] = $scope;
        if ($attrs.tokenUrl) {
            Idx.setTokenURL($attrs.tokenUrl);
        }
        Stratus.Internals.CssLoader(localDistStyle).then();
        let defaultOptions;
        this.$onInit = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d, _e;
            var _f, _g, _h, _j, _k;
            $scope.urlLoad = $attrs.urlLoad && isJSON($attrs.urlLoad) ? JSON.parse($attrs.urlLoad) : true;
            $scope.detailsLinkPopup = $attrs.detailsLinkPopup && isJSON($attrs.detailsLinkPopup) ?
                JSON.parse($attrs.detailsLinkPopup) : true;
            $scope.detailsLinkUrl = $attrs.detailsLinkUrl || '/property/member/details';
            $scope.detailsLinkTarget = $attrs.detailsLinkTarget || '_self';
            $scope.options = $attrs.options && isJSON($attrs.options) ? JSON.parse($attrs.options) : {};
            (_a = (_f = $scope.options).order) !== null && _a !== void 0 ? _a : (_f.order = null);
            (_b = (_g = $scope.options).page) !== null && _b !== void 0 ? _b : (_g.page = null);
            (_c = (_h = $scope.options).perPage) !== null && _c !== void 0 ? _c : (_h.perPage = 25);
            (_d = (_j = $scope.options).images) !== null && _d !== void 0 ? _d : (_j.images = { limit: 1 });
            (_e = (_k = $scope.options).where) !== null && _e !== void 0 ? _e : (_k.where = {});
            defaultOptions = JSON.parse(JSON.stringify($scope.options.where));
            Idx.registerListInstance($scope.elementId, moduleName, $scope);
            const urlOptions = {};
            yield $scope.search(urlOptions.Search, true, false);
            Idx.emit('init', $scope);
        });
        $scope.$watch('collection.models', () => {
            if ($scope.collection.completed) {
                Idx.emit('collectionUpdated', $scope, $scope.collection);
            }
        });
        $scope.getPageModels = () => {
            const members = [];
            const models = $scope.collection.models;
            models.slice(($scope.query.perPage * ($scope.query.page - 1)), ($scope.query.perPage * $scope.query.page)).forEach((member) => {
                members.push(member);
            });
            return members;
        };
        $scope.scrollToModel = (model) => {
            $anchorScroll(`${$scope.elementId}_${model._id}`);
        };
        $scope.search = $scope.searchMembers = (options, refresh, updateUrl) => __awaiter(this, void 0, void 0, function* () {
            return $q((resolve) => __awaiter(this, void 0, void 0, function* () {
                options !== null && options !== void 0 ? options : (options = {});
                updateUrl = updateUrl === false ? updateUrl : true;
                if (refresh) {
                    $scope.options.page = 1;
                }
                if (options.where && Object.keys(options.where).length > 0) {
                    delete ($scope.options.where);
                    $scope.options.where = options.where;
                    if ($scope.options.where.Page) {
                        $scope.options.page = $scope.options.where.Page;
                        delete ($scope.options.where.Page);
                    }
                    if ($scope.options.where.Order) {
                        $scope.options.order = $scope.options.where.Order;
                        delete ($scope.options.where.Order);
                    }
                }
                else {
                    options = $scope.options.where || {};
                }
                if ($scope.options.page) {
                    options.Page = $scope.options.page;
                }
                if (options.Page <= 1) {
                    delete (options.Page);
                }
                if ($scope.options.order && $scope.options.order.length > 0) {
                    options.Order = $scope.options.order;
                }
                Idx.emit('searching', $scope, clone($scope.query));
                try {
                    const results = yield Idx.fetchMembers($scope.elementId, 'collection', $scope.options, refresh);
                    Idx.emit('searched', $scope, clone($scope.query));
                    resolve(results);
                }
                catch (e) {
                    console.error('Unable to fetchMembers:', e);
                }
            }));
        });
        $scope.pageChange = (pageNumber, ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            Idx.emit('pageChanging', $scope, clone($scope.options.page));
            if (ev) {
                ev.preventDefault();
            }
            $scope.options.page = pageNumber;
            yield $scope.search();
            Idx.emit('pageChanged', $scope, clone($scope.options.page));
        });
        $scope.pageNext = (ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            if (!$scope.options.page) {
                $scope.options.page = 1;
            }
            if ($scope.collection.completed && $scope.options.page < $scope.collection.meta.data.totalPages) {
                if (isString($scope.options.page)) {
                    $scope.options.page = parseInt($scope.options.page, 10);
                }
                yield $scope.pageChange($scope.options.page + 1, ev);
            }
        });
        $scope.pagePrevious = (ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            if (!$scope.options.page) {
                $scope.options.page = 1;
            }
            if ($scope.collection.completed && $scope.options.page > 1) {
                if (isString($scope.options.page)) {
                    $scope.options.page = parseInt($scope.options.page, 10);
                }
                const prev = $scope.options.page - 1 || 1;
                yield $scope.pageChange(prev, ev);
            }
        });
        $scope.orderChange = (order, ev) => __awaiter(this, void 0, void 0, function* () {
            if ($scope.collection.pending) {
                return;
            }
            Idx.emit('orderChanging', $scope, clone(order));
            if (ev) {
                ev.preventDefault();
            }
            $scope.options.order = order;
            yield $scope.search(null, true, true);
            Idx.emit('orderChanged', $scope, clone(order));
        });
        $scope.highlightModel = (model, timeout) => {
            var _a;
            timeout !== null && timeout !== void 0 ? timeout : (timeout = 0);
            (_a = model._unmapped) !== null && _a !== void 0 ? _a : (model._unmapped = {});
            $scope.$applyAsync(() => {
                model._unmapped._highlight = true;
            });
            if (timeout > 0) {
                $timeout(() => {
                    $scope.unhighlightModel(model);
                }, timeout);
            }
        };
        $scope.unhighlightModel = (model) => {
            var _a;
            if (model) {
                (_a = model._unmapped) !== null && _a !== void 0 ? _a : (model._unmapped = {});
                $scope.$applyAsync(() => {
                    model._unmapped._highlight = false;
                });
            }
        };
        $scope.displayModelDetails = (model, ev) => {
            if (ev) {
                ev.preventDefault();
            }
            if ($scope.detailsLinkPopup === true) {
                const templateOptions = {
                    element_id: 'property_member_detail_popup',
                    service: model._ServiceId,
                    'member-key': model.MemberKey,
                    'page-title': true
                };
                if ($scope.googleApiKey) {
                    templateOptions['google-api-key'] = $scope.googleApiKey;
                }
                let template = '<md-dialog aria-label="' + model.MemberKey + '">' +
                    '<stratus-idx-member-details ';
                forEach(templateOptions, (optionValue, optionKey) => {
                    template += `${optionKey}='${optionValue}'`;
                });
                template +=
                    '></stratus-idx-member-details>' +
                        '</md-dialog>';
                $mdDialog.show({
                    template,
                    parent: element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true
                })
                    .then(() => {
                }, () => {
                    Idx.setPageTitle();
                    $timeout(() => Idx.unregisterDetailsInstance('property_member_detail_popup', 'member'), 10);
                });
            }
            else {
                $window.open($scope.getDetailsURL(model), $scope.detailsLinkTarget);
            }
        };
        $scope.injectMemberDetails = (member) => __awaiter(this, void 0, void 0, function* () {
            $rootScope.$applyAsync(() => __awaiter(this, void 0, void 0, function* () {
                yield $scope.variableInject(member);
            }));
        });
        $scope.variableInject =
            (member) => __awaiter(this, void 0, void 0, function* () {
                $scope.variableSyncing = $attrs.variableSync && isJSON($attrs.variableSync) ? JSON.parse($attrs.variableSync) : {};
                Object.keys($scope.variableSyncing).forEach(elementId => {
                    const varElement = Idx.getInput(elementId);
                    if (varElement) {
                        if (Object.prototype.hasOwnProperty.call(member, $scope.variableSyncing[elementId])) {
                            varElement.val(member[$scope.variableSyncing[elementId]]);
                        }
                        else if ($scope.variableSyncing[elementId] === 'MemberFullName' &&
                            Object.prototype.hasOwnProperty.call(member, 'MemberFirstName') &&
                            Object.prototype.hasOwnProperty.call(member, 'MemberLastName')) {
                            varElement.val(member.MemberFirstName + ' ' + member.MemberLastName);
                        }
                        else if ($scope.variableSyncing[elementId] === 'MemberFirstName' &&
                            !Object.prototype.hasOwnProperty.call(member, 'MemberFirstName') &&
                            Object.prototype.hasOwnProperty.call(member, 'MemberFullName')) {
                            const nameArray = member.MemberFullName.split(' ');
                            const firstName = nameArray.shift();
                            varElement.val(firstName);
                        }
                        else if ($scope.variableSyncing[elementId] === 'MemberLastName' &&
                            !Object.prototype.hasOwnProperty.call(member, 'MemberLastName') &&
                            Object.prototype.hasOwnProperty.call(member, 'MemberFullName')) {
                            const nameArray = member.MemberFullName.split(' ');
                            const lastName = nameArray.join(' ');
                            varElement.val(lastName);
                        }
                        else if ($scope.variableSyncing[elementId] === 'OfficeNumber') {
                            if (Object.prototype.hasOwnProperty.call(member, 'OfficeMlsId')) {
                                varElement.val(member.OfficeMlsId);
                            }
                            else if (Object.prototype.hasOwnProperty.call(member, 'OfficeKey')) {
                                varElement.val(member.OfficeKey);
                            }
                        }
                        varElement.triggerHandler('input');
                    }
                });
            });
        $scope.on = (emitterName, callback) => Idx.on($scope.elementId, emitterName, callback);
        $scope.remove = () => {
        };
    },
    templateUrl: ($attrs) => `${localDir}${$attrs.template || componentName}.component${min}.html`
};

//# sourceMappingURL=list.component.js.map
